import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";
import Reveal from "@/components/base/Reveal";
import { brand } from "@/mocks/siteData";
import ShareStoryHero from "./components/ShareStoryHero";
import ShareStoryForm from "./components/ShareStoryForm";
import ShareStorySteps from "./components/ShareStorySteps";

const GUIDELINES = [
  "Write in your own voice — first person works beautifully.",
  "Share something specific: a place, a person, a season, a dish.",
  "Names and details are welcome; we ask permission before publishing.",
  "You keep the copyright. You can ask us to remove it any time.",
];

export default function ShareStory() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Seo
        title={`Share Your Story | ${brand.name}`}
        description="Visited a farm, met a farmer or carry a memory of the land? Share your story with Rythugaru — the best submissions join our public journal."
        path="/share-your-story"
        keywords="share your story, farmer stories, agri tourism stories, Konaseema stories, rural India journal"
        image="https://readdy.ai/api/search-image?query=Open%20worn%20notebook%20and%20pen%20resting%20on%20a%20wooden%20table%20beside%20fresh%20paddy%20seedlings%20with%20soft%20morning%20light%20streaming%20in%2C%20warm%20earthy%20green%20and%20amber%20tones%2C%20editorial%20still%20life%20photography%2C%20shallow%20depth%20of%20field%2C%20ultra%20detailed&width=1200&height=630&seq=share-story-og&orientation=landscape"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "Share Your Story",
          description: "Share a farm or village story with Rythugaru Agri Tourism.",
          inLanguage: "en",
        }}
      />
      <Navbar />
      <main>
        <ShareStoryHero />

        <section className="bg-background-50 py-16 md:py-24">
          <div className="w-full px-4 md:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
              <div className="lg:col-span-7">
                <ShareStoryForm />
              </div>

              <div className="lg:col-span-5">
                <Reveal className="bg-secondary-50 border border-secondary-200 rounded-lg p-6 md:p-8">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-900">
                    <i className="ri-lightbulb-line text-2xl"></i>
                  </span>
                  <h3 className="font-heading text-xl md:text-2xl text-foreground-950 font-semibold mt-5">
                    What makes a great story
                  </h3>
                  <ul className="mt-5 space-y-3.5">
                    {GUIDELINES.map((item) => (
                      <li key={item} className="flex items-start gap-3">
                        <span className="w-5 h-5 flex items-center justify-center text-primary-700 shrink-0 mt-0.5">
                          <i className="ri-checkbox-circle-line"></i>
                        </span>
                        <span className="text-sm text-foreground-700 leading-relaxed">{item}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="mt-7 pt-6 border-t border-secondary-200">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      Prefer to read first? Browse the journal our community has already built.
                    </p>
                    <Link
                      to="/stories"
                      className="mt-4 inline-flex items-center gap-2 border border-background-300 text-foreground-800 text-sm font-semibold px-5 py-3 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-book-open-line"></i> Read the journal
                    </Link>
                  </div>
                </Reveal>
              </div>
            </div>
          </div>
        </section>

        <ShareStorySteps />
      </main>
      <Footer />
    </div>
  );
}